import click from '../sounds/click'
import NotInvestigatedClueIcon from './NotInvestigatedClueIcon'

type Props = Readonly<{
  /**
   * Accessible label to describe what the button does in a non-visual way.
   */
  label: string
}> &
  React.ComponentProps<'button'>

function NotInvestigatedClueButton({
  label,
  onClick,
  ...props
}: Props): React.JSX.Element {
  return (
    <button
      className="rounded-full border border-button-border bg-clue-not-investigated-fill p-2 text-tertiary-3 shadow-clue-not-investigated hover:bg-clue-not-investigated-fill-hover hover:shadow-clue-not-investigated-hover active:translate-y-px active:bg-clue-not-investigated-fill-hover active:shadow-clue-not-investigated-active lg:border-2 lg:p-3 lg:shadow-clue-not-investigated-lg lg:hover:shadow-clue-not-investigated-lg-hover lg:active:translate-y-0.5 lg:active:shadow-clue-not-investigated-lg-active"
      onClick={(ev) => {
        click.play()
        onClick?.(ev)
      }}
      {...props}
    >
      <NotInvestigatedClueIcon
        className="h-6 w-6 lg:h-[30px] lg:w-[30px]"
        aria-hidden
      />
      <span className="sr-only">{label}</span>
    </button>
  )
}

export default NotInvestigatedClueButton
